import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: { fullscreen: true },
    },
    {
        path: "/about-me",
        name: "AboutMe",
        component: () => import("@/views/AboutMe"),
    },
    {
        path: "/knowledge",
        name: "Knowledge",
        component: () => import("@/views/Knowledge"),
    },
    {
        path: "/projects",
        name: "Projects",
        component: () => import("@/views/Projects"),
    },
    {
        path: "/contact-me",
        name: "ContactMe",
        component: () => import("@/views/ContactMe"),
    },
    {
        path: "/cv",
        name: "CV",
        component: () => import("@/views/Cv"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
